import { CircularProgress } from '@mui/material'

const ScreenLoadingPlaceholder: React.FC = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', paddingTop: 80 }}>
            <CircularProgress />
        </div>
    )
}

export default ScreenLoadingPlaceholder
